import { createSlice } from '@reduxjs/toolkit';

let initialState = {
  loader: {
    visible: false,
    label: ''
  },
  toastInfo: '',
  toastSuccess: '',
  toastError: '',
  countries: null,
  languages: null
};

const entities = createSlice({
  name: 'entitiesReducer',
  initialState: initialState,
  reducers: {
    showLoader(state, action) {
      state.loader.visible = true;
      state.loader.label = action.payload;
    },
    hideLoader(state, action) {
      state.loader.visible = false;
    },
    setToastInfo(state, action) {
      state.toastInfo = action.payload;
    },
    setToastSuccess(state, action) {
      state.toastSuccess = action.payload;
    },
    setToastError(state, action) {
      state.toastError = action.payload;
    },
    setCountries(state, action) {
      state.countries = action.payload;
    },
    setLanguages(state, action) {
      state.languages = action.payload;
    }
  }
});

export const { showLoader, hideLoader, setToastSuccess, setToastInfo, setToastError, setCountries, setLanguages } =
  entities.actions;

export default entities.reducer;
